import { render, staticRenderFns } from "./SearchFeatured.vue?vue&type=template&id=12afcbc5&"
import script from "./SearchFeatured.vue?vue&type=script&lang=js&"
export * from "./SearchFeatured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports